import i18n from 'i18next'

// The backend sends species and breed names in Thai. English shows these
// instead. Replacement runs longest name first (see the sort below) so
// "กุ้งขาว" wins over "กุ้ง" and "ปลานิล" is not turned into "Fishนิล".
const SPECIES_EN_ENTRIES: [string, string][] = [
  ['กุ้งขาวแวนนาไม', 'Vannamei shrimp'],
  ['กุ้งก้ามกราม', 'Giant river prawn'],
  ['กุ้งกุลาดำ', 'Black tiger shrimp'],
  ['กุ้งขาว', 'White shrimp'],
  ['กุ้งดำ', 'Black shrimp'],
  ['ปลานิล', 'Nile tilapia'],
  ['ปลาทับทิม', 'Red tilapia'],
  ['ปลาดุก', 'Catfish'],
  ['ปลากะพง', 'Sea bass'],
  ['กุ้ง', 'Shrimp'],
  ['ปลา', 'Fish'],
  ['หอย', 'Shellfish'],
  ['ปู', 'Crab'],
]

export const SPECIES_EN: [string, string][] = [...SPECIES_EN_ENTRIES].sort(
  (a, b) => b[0].length - a[0].length
)

const isEnglish = () => (i18n.language ?? '').startsWith('en')

const SPECIES_EN_PATTERN = new RegExp(SPECIES_EN.map(([th]) => th).join('|'), 'g')
const SPECIES_EN_MAP = new Map(SPECIES_EN)

/**
 * Replaces Thai species/breed names inside [text] with English ones. One pass
 * with a longest-first alternation, so an already-replaced name is never
 * matched again.
 */
export const replaceSpeciesNamesEn = (text: string) =>
  text.replace(SPECIES_EN_PATTERN, (m) => SPECIES_EN_MAP.get(m) ?? m)

/** Species name for display: English name in English, as-is otherwise. */
export const speciesDisplayName = (species?: string | null) =>
  isEnglish() ? replaceSpeciesNamesEn(species ?? '') : species ?? ''

/**
 * A label followed by the species, e.g. "ประวัติการย้าย" + "ปลา". Thai/Burmese
 * keep the old concatenation; English reads "Transfer history (Fish)".
 */
export const labelWithSpecies = (label: string, species?: string | null) => {
  if (!species) return label
  return isEnglish() ? `${label} (${replaceSpeciesNamesEn(species)})` : `${label}${species}`
}
